"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const IconButton_1 = tslib_1.__importDefault(require("@mui/material/IconButton"));
const Tooltip_1 = tslib_1.__importDefault(require("@mui/material/Tooltip"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const InternalComponents_1 = require("./InternalComponents");
const getStyles = () => ({
    wrapper: {
        height: "55px",
        padding: (theme) => theme.spacing(0, 2),
        display: "grid",
        gridTemplateAreas: `"title actions"`,
        gridTemplateColumns: "1fr max-content",
        alignItems: "center",
    },
    title: {
        gridArea: "title",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    titleVisuallyHidden: {
        gridArea: "title",
        overflow: "hidden",
        border: "0",
        clip: "rect(0 0 0 0)",
        height: "1px",
        width: "1px",
        margin: "-1px",
        padding: "0",
        position: "absolute",
    },
    actions: {
        gridArea: "actions",
        justifyContent: "end",
    },
});
/**
 * This is a component to render the header within a GridCard.
 *
 * @remarks
 *  - This is to be wrapped inside the GridCard component before the GridCardContent component
 *  - A title is mandatory for this component. The title can, however, be hidden visually by
 *    setting the hideTitleVisually prop. This is to maintain good semantics and at the same time give the developer flexibility.
 *
 *
 * @example Basic usage
 * ```tsx
 * <GridCard loading={false}>
 *     <GridCardHeader title="Title of ur choice" />
 *     <GridCardContent >
 *         <div> This is some content to display in a GridCard </div>
 *     </GridCardContent>
 * </GridCard>
 * ```
 * @category component
 */
const GridCardHeader = ({ title, hideTitleVisually = false, size = "lg", actions, menuIconTooltip, ActionMenuProps, }) => {
    const styles = getStyles();
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (react_1.default.createElement(Box_1.default, { component: "span", sx: styles.wrapper },
        !hideTitleVisually ? (react_1.default.createElement(Tooltip_1.default, { title: title ? title : "" },
            react_1.default.createElement(Typography_1.default, { sx: styles.title, variant: size === "sm" ? "subtitle1" : "h6", variantMapping: { subtitle1: "h3", h6: "h3" }, children: title }))) : (react_1.default.createElement(Typography_1.default, { sx: styles.titleVisuallyHidden, variant: size === "sm" ? "subtitle1" : "h6", variantMapping: { subtitle1: "h3", h6: "h3" }, children: title })),
        actions?.length === 1 && (react_1.default.createElement(Tooltip_1.default, { title: actions[0]?.title, placement: "right", sx: styles.actions },
            react_1.default.createElement(IconButton_1.default, { size: "small", color: "default", "aria-label": actions[0]?.title, component: "span", onClick: actions[0]?.onActionClick, children: actions[0]?.icon }))),
        actions?.length > 1 && (react_1.default.createElement(InternalComponents_1.ActionMenu, { sx: styles.actions, actions: actions, menuIconTooltip: menuIconTooltip, onClose: handleClose, onMenuClick: handleClick, anchorEl: anchorEl, open: Boolean(anchorEl), keepMounted: true, ...ActionMenuProps }))));
};
exports.default = GridCardHeader;
